import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService, LanguageService } from '@haleo-frontend/data-access/services';
import { AbstractComponent, AppService, regex, TrackingUtils } from '@haleo-frontend/utils';
import { LoadingController } from '@ionic/angular';
import { lastValueFrom } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'haleo-reset-password-form',
    templateUrl: './reset-password-form.component.html'
})
export class ResetPasswordFormComponent extends AbstractComponent implements OnInit {

    resetForm: FormGroup;
    linkSent: boolean;
    locale: string;

    constructor(private formBuilder: FormBuilder,
                private loadingCtrl: LoadingController,
                private authService: AuthService,
                private appService: AppService,
                private languageService: LanguageService) {
        super();
    }

    ngOnInit() {
        this.locale = this.languageService.locale;
        this.resetForm = this.formBuilder.group({
            email: ['', [Validators.required, Validators.pattern(regex.emailValidator)]]
        });

        this.resetForm.controls.email.valueChanges
            .pipe(distinctUntilChanged())
            .subscribe(value => this.resetForm.controls.email.setValue(value.toLowerCase()));
    }

    async sendLink() {

        const loading = await this.loadingCtrl.create();
        await loading.present();

        try {

            const appKey = this.appService.getAppKey();
            await lastValueFrom(this.authService.sendResetPasswordLink(this.resetForm.value.email, appKey, this.locale)
                .pipe(takeUntil(this.destroy)));

            this.linkSent = true;
            TrackingUtils.trackEvent('reset_password_link_sent');

        } catch (error: any) {

            if (error.status === 422 && error.error.errors && error.error.errors.email) {
                const email: AbstractControl = this.resetForm.controls.email;
                email.setErrors({api: error.error.errors.email[0]});
            }
        }

        await loading.dismiss();
    }
}
